module.exports = __webpack_public_path__ + "static/media/icon_65.83901bd3.svg";